import React from "react";
import { Dialog, Transition } from "@headlessui/react";

export default function Modal({ isOpen, onClose, onConfirm, title, description }) {
    return (
        <Transition show={isOpen} appear as={React.Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                {/* Background overlay */}
                <Transition.Child
                    as={React.Fragment}
                    enter="ease-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-30" />
                </Transition.Child>

                {/* Modal container */}
                <div className="fixed inset-0 flex items-center justify-center p-4">
                    <Transition.Child
                        as={React.Fragment}
                        enter="ease-out duration-200"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-150"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="w-full max-w-md rounded bg-white p-6 shadow-xl">
                            <Dialog.Title className="text-lg font-medium text-gray-800 mb-2">
                                {title}
                            </Dialog.Title>
                            <Dialog.Description className="text-sm text-gray-600 mb-4">
                                {description}
                            </Dialog.Description>

                            <div className="flex justify-end gap-2">
                                <button
                                    onClick={onClose}
                                    className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800"
                                >
                                    Annuleren
                                </button>
                                <button
                                    onClick={onConfirm}
                                    className="px-4 py-2 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition"
                                >
                                    Ja, verwijderen
                                </button>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
}
